import React from "react";
import './ShowCase.css'
import pdfFile from '../../utils/files/pdf.pdf'
const ShowCase = () => {
    return(
        <>
        <div className="showcase-wrapper">
            <div className="showcase-wrapper-content">
                <div className="ctr">
                <h1>Invest in the future of</h1>
                <h2>sustainable energy!</h2>
                <p>Join us in supporting the development of </p>
                <p>green hydrogen production in Egypt.</p>
                <a href={pdfFile} target="_blank">Egypt's Hydrogen Strategy</a>
                </div>
            </div>
    
        </div>
        </>
    )
}
export default ShowCase